import { useRef, useEffect } from 'react';
import { PulseUser } from './usePulseSocket';

/**
 * Fires a single 8ms haptic tap when a silent room becomes active
 * (someone starts typing after nobody was typing).
 * Mobile-only — degrades gracefully on unsupported browsers.
 */
export function useHaptic(users: Map<string, PulseUser>) {
  const wasQuietRef = useRef(true);

  useEffect(() => {
    const anyoneTyping = Array.from(users.values()).some(u => u.buffer.length > 0);

    if (anyoneTyping && wasQuietRef.current) {
      if (navigator.vibrate) {
        navigator.vibrate(8);
      }
    }

    wasQuietRef.current = !anyoneTyping;
  }, [users]);
}
